export default __webpack_public_path__ + "static/media/banner-guarantees.e154bf5f.png";